import * as feedbackActions from './actions';
import { IFeedbackState } from './types';

const initialState: IFeedbackState = {
  loading: false,
  open: false,
  pristine: true,
};

const reducer = (
  state: IFeedbackState = initialState,
  action: feedbackActions.Actions
): IFeedbackState => {
  switch (action.type) {
    case feedbackActions.OPEN_FEEDBACK_MODAL:
      return {
        ...state,
        open: action.payload.open,
        pristine: false,
      };
    case feedbackActions.SEND_FEEDBACK:
      return {
        ...state,
        loading: true,
      };
    case feedbackActions.SEND_FEEDBACK_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case feedbackActions.SEND_FEEDBACK_SUCCESS:
      return {
        ...state,
        loading: false,
        pristine: true,
      };
    default:
      return state;
  }
};

export default reducer;
